<template>
    <div
        class="o-menu-header menu-header"
    >
        <div class="o-menu-header__description">{{description}}</div>
        <img
            src="../../../assets/images/storo-storsenter-logo.svg"
            :alt="`${$t('company-info_logo')}`"
            class="o-menu-header__logo"
        >
        <!-- TO DO CHANGE ../../../assets/images/storo-storsenter-logo.svg TO LOGO FROM CONFIG -->
        <div class="o-menu-header__close-message">
            <svg-icon
                original
                name="icons/icon-clock"
                class="o-menu-header__close-message__icon"
            />
            {{
                currentDayData.closed ? $t('ui.store-closed', { time: closeTime }) : $t('ui.center-open-till', { closeTime })
            }}

        </div>
    </div>
</template>

<script>

import { mapState, mapGetters } from 'vuex';

import {getDayNumber} from '../../../utils/helpers/dateConverter';

export default {
    name: 'OMenuHeader',
    props: {
        title: {
            type: String,
            default: ''
        },
        description: {
            type: String,
            default: ''
        }
    },
    computed: {
        ...mapState({
            openingHours: state => state.map.meta.otg_opening_hours,
        }),
        ...mapGetters(['getMap', 't']),
        logo() {
            return this.t(this.getMap,'logo') || null;
        },
        currentDayData() {
            return this.openingHours.find(day => day.openDay == getDayNumber())
        },
        closeTime() {
            if(this.currentDayData.openPeriods[0]?.closeTime) {
                return this.currentDayData.openPeriods[0].closeTime
            } else {
                return this.$t('ui.no-close-time')
            }

        }
    }
}
</script>

<style lang="scss">
@import "o-menu-header";
</style>
